import React from 'react';

/**
 * FieldShell — shared layout wrapper for all FormKit fields.
 * Renders label, required asterisk, helper text, error message,
 * and wraps the control slot in consistent markup.
 */
const FieldShell = ({
    label,
    htmlFor,
    required = false,
    helperText,
    errorMessage,
    invalid = false,
    disabled = false,
    readOnly = false,
    fluid = true,
    className = '',
    children,
    trailing,      // optional trailing element next to label row (e.g. "Confirmado" badge)
}) => {
    const fieldCls = [
        'fk-field',
        fluid && 'fk-field--fluid',
        className,
    ].filter(Boolean).join(' ');

    return (
        <div className={fieldCls}>
            {(label || trailing) && (
                <div className="fk-label-row">
                    {label && (
                        <label className="fk-label" htmlFor={htmlFor}>
                            {label}
                            {required && <span className="fk-required-star"> *</span>}
                        </label>
                    )}
                    {trailing}
                </div>
            )}
            {children}
            {invalid && errorMessage && (
                <span className="fk-error-msg">{errorMessage}</span>
            )}
            {helperText && !errorMessage && (
                <span className="fk-helper">{helperText}</span>
            )}
        </div>
    );
};

export default FieldShell;
